import React, { useEffect, useState } from 'react';
import NewsCard from '../components/NewsCard';
import api from '../api';
import './UjalaNews.css';

function UjalaNews() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const fetchRRNews = async () => {
      try {
        const res = await api.get('/api/news/ujala');
        if (res && res.data && res.data.success) setItems(res.data.data || []);
      } catch (err) {
        // If server returned non-JSON or axios error, log useful details
        if (err.response && err.response.data) {
          console.error('RR news fetch error response:', err.response.status, err.response.data);
        } else {
          console.error('RR news fetch error:', err.message || err);
        }
      }
    };
    fetchRRNews();
  }, []);

  return (
    <div className="container ujala-page">
      <div className="ujala-heading">
        <h2>RR न्यूज़ टीवी</h2>
        <div className="underline" aria-hidden="true" />
      </div>
      <div className="news-grid">
        {items.length === 0 && <p>No RR news available</p>}
        {items.map(n => <NewsCard key={n._id} news={n} />)}
      </div>
    </div>
  );
}

export default UjalaNews;
